import { get } from 'lodash';
import {
  centreSerivce,
  MS_PHASE_3_ENDPOINTS,
  onboardingService,
} from 'utils/msEndpointConstants';
import DatadogHandler from '../utils/datadog';
import { DEFAULT_ERROR } from '../utils/constants';

const { CENTRE, CENTRE_WAITLIST } = MS_PHASE_3_ENDPOINTS;
const fileName = 'redux/actions/TransferService.js';

export const msGetAllAvailableVacancy = async (_, reqData) => {
  try {
    const reqBody = {
      ...(reqData?.centreID && {
        centre_id: reqData?.centreID,
      }),
      ...(reqData?.enrolmentDate && {
        enrolment_date: reqData?.enrolmentDate,
      }),
      ...(reqData?.levelID && {
        level_id: reqData?.levelID,
      }),
      ...(reqData?.programID && {
        program_id: reqData?.programID,
      }),
    };
    const centreSvc = centreSerivce();
    const resp = await centreSvc.post(...CENTRE.getAvailableVacancy(reqBody));
    const vacancy = resp?.data?.vacancy || 0;
    return {
      success: true,
      data: {
        getAvailableVacancy: vacancy,
      },
    };
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'msGetAllAvailableVacancy',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: get(ex, 'message', DEFAULT_ERROR),
    };
  }
};

export const msGetLeadOfferedForTransfer = async (_, reqData) => {
  try {
    const { transferDraftID } = reqData;
    const onboardingSvc = onboardingService();
    const resp = await onboardingSvc.get(
      CENTRE_WAITLIST.getLeadOfferedToTransferDraft(transferDraftID)
    );
    return {
      success: true,
      data: {
        hasLeadBeenOfferedForTransferDraft: get(resp, 'data.offered', false),
      },
    };
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'msGetLeadOfferedForTransfer',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: get(ex, 'response.data.error', DEFAULT_ERROR),
    };
  }
};

export const msGetCentreAvailableVacancy = async () => {
  try {
    const resp = await Promise.resolve();
    return {
      success: true,
      data: {
        data: {
          vacancyAvailableInCentreForTransfer: get(
            resp,
            'vaccancyAvailableInCentreForTransfer',
            false
          ),
        },
      },
    };
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'msGetCentreAvailableVacancy',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: get(ex, 'response.data.error', DEFAULT_ERROR),
    };
  }
};

export const msApproveTransferRequestSource = async () => {
  try {
    const resp = await Promise.resolve();
    return {
      success: get(resp, 'data.success', false),
    };
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'msApproveTransferRequestSource',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: get(ex, 'response.data.error', DEFAULT_ERROR),
    };
  }
};

export const msRejectTransferRequestSource = async () => {
  try {
    const resp = await Promise.resolve();
    return {
      success: get(resp, 'data.success', false),
    };
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'msRejectTransferRequestSource',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: get(ex, 'response.data.error', DEFAULT_ERROR),
    };
  }
};

export default { msGetAllAvailableVacancy };
